module.exports = __webpack_public_path__ + "static/media/boomstam-2.4380737c.jpeg";